/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPharmacyLogoImageRequestBodyTypename = "PutPharmacyLogoImageRequestBody" as const;

/**
 *
 * @export
 * @interface PutPharmacyLogoImageRequestBody
 */
export interface PutPharmacyLogoImageRequestBody {
  /**
   *
   * @type {string}
   * @memberof PutPharmacyLogoImageRequestBody
   */
  logoImageData?: string;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPharmacyLogoImageRequestBody
   */
  readonly __typename?: string;
}

export function PutPharmacyLogoImageRequestBodyFromJSON(json: any): PutPharmacyLogoImageRequestBody {
  return PutPharmacyLogoImageRequestBodyFromJSONTyped(json, false);
}

export function PutPharmacyLogoImageRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPharmacyLogoImageRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPharmacyLogoImageRequestBodyTypename,

    logoImageData: !exists(json, "logo_image_data") ? undefined : json["logo_image_data"],
  };
}

export function PutPharmacyLogoImageRequestBodyToJSON(object?: PutPharmacyLogoImageRequestBody | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    logo_image_data: value.logoImageData,
  };
}
